const patterns = {
    persianLetters: {
        value: '^[\u0600-\u06FF\\s]+$',
        errorMessage: 'از حروف فارسی استفاده کنید.'
    },

    number: (errorMessage) => ({
        value: '^[0-9]+$',
        errorMessage: errorMessage || 'از اعداد استفاده کنید.'
    }),

    email: {
        value: '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
        errorMessage: 'آدرس ایمیل را به درستی وارد کنید.'
    },

    emailOrMobile: {
        value: '^(?:[\\w\\-\\.]+@([\\w\\-]+\\.)+[\\w\\-]{2,4})$|^(?:\\+?[\u06F0-\u06F90-9]{10,13})$',
        errorMessage: 'شماره موبایل یا آدرس ایمیل را به درستی وارد کنید.'
    },

    url: {
        value: '^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})([/\\w .-]*)*\\\\?([\\w%&=-]*)',
        errorMessage: 'لینک را به درستی وارد کنید.'
    },

    slug: (errorMessage) => ({
        value: '^[\u0600-\u06FFA-Za-za-z0-9]+(?:-[\u0600-\u06FFA-Za-za-z0-9]+)*$',
        errorMessage: errorMessage || 'slug وارد شده معتبر نیست.'
    }),
    formula: {
        value: /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/,
        errorMessage: 'از اعداد استفاده کنید. '
    },
}

export default patterns;
